import { PatientGroupsTabs } from './PatientGroupsTabs';

export const PatientGroupsSettings = (): JSX.Element => {
   return <PatientGroupsTabs />;
};
